import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { TransferAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-transfer-slot-v3',
    templateUrl: './transfer-slot-v3.component.html',
    styleUrl: './transfer-slot-v3.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TransferSlotComponentV3 implements SheetSlotComponentBase {

	@Input() action!: TransferAction;
	value = null;

	constructor() {
	}
}